import { Box, Stack, Typography } from "@mui/material";
import { RateIndicator } from "../../../types/enums";
import { RateIndicatorIcon } from "../../ui/RateIndicatorIcon";

export const AnalyticItem = ({
  title,
  percentage,
  color,
  indicatorRate,
  indicatorChange,
  indicatorChangeAt,
}: {
  title: string;
  percentage: number;
  color: string;
  indicatorRate?: RateIndicator;
  indicatorChange?: number;
  indicatorChangeAt?: string;
}) => {
  return (
    <Stack gap="4px">
      <Typography variant="body1" color="#1F293299">
        {title}
      </Typography>
      <Stack direction="row" gap="4px" alignItems="center">
        <RateIndicatorIcon
          indicatorRate={indicatorRate}
          indicatorChange={indicatorChange}
          indicatorChangeAt={indicatorChangeAt}
        />
        <Typography variant="body1" sx={{ fontSize: "16px" }} color="#051123">
          {percentage ?? 0}%
        </Typography>
        <Box sx={{ width: "12px", height: "12px", backgroundColor: color }} />
      </Stack>
    </Stack>
  );
};
